import * as React from "react";
import { useTranslation } from 'react-i18next';
import IconRefresh from "./Icons/IconRefresh";
import MuiLink from "./MuiExtras/MuiLink";

interface IProps {
    onClick: () => void;
}

export const RefreshLink: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    return <MuiLink onClick={props.onClick} ><IconRefresh />{t("Common.Literals.ReloadText")}</MuiLink>;
};


